import {useTranslation} from "react-i18next";

const useProductName = () => {
    const { t } = useTranslation();

    const translatedProductName = (productName) => {
        return t(`productNames.${productName}`);
    };

    return {
        translatedProductName
    };
};

export default useProductName;
